import React, { useState } from "react";
import { useFormik } from "formik";
// import { Button } from "react-bootstrap";
import { Button, Form, Modal } from "react-bootstrap";
import '../login.css'
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { BiShowAlt } from "react-icons/bi";
import { MdEmail, MdSms } from "react-icons/md";
import { AXIOS, api_key } from "../../../config";
import { toast } from "react-toastify";
import check from '../../../assets/images/signin/checkmark.svg'
export default function EmailInput({ formik }) {
  const [steps, setSteps] = useState(0)
  const [confirmPassword, setShownConfirmPassword] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [userId, setUserId] = useState('')



  const location = useLocation();
  console.log('console.log(location.pathname)', location.pathname == '/resetPassword')

  const getOtp = async () => {
    // setMiliseconds(miliseconds + 1)

    try {
      let id = await AXIOS.post(`/getUserId`, {
        api_key: api_key,
        email: formik.values.email,
      });
      setUserId(id.data.data[0].user_id)
      console.log('id.data.data[0].user_id', id.data)
      let otpSent = await AXIOS.post(`/sendMail`, {
        api_key: api_key,
        user_id: id.data.data[0].user_id,
        reason: "change_password",
      })
      toast.success("Pin code sent to Email", { icon: <MdEmail /> });
      setSteps(steps + 1)
    } catch (error: any) {
      toast.error(error.message)
    }
  }


  const verifyPin = async () => {
    try {
      let validatePin = await AXIOS.post(`/forgetPinCheck`, {
        api_key: api_key,
        user_id: userId,
        mailPin: formik.values.pin
      })
      console.log('validatePin', validatePin.data.status)

      if (validatePin.data.status == 'fail') {
        toast.error(validatePin.data.showableMessage)

      }
      else {
        setSteps(steps + 1)
      }

    } catch (error: any) {
      toast.error(error)

    }
  }
  const updatePassword = async () => {
    try {
      let updatePassword = await AXIOS.post(`/forgetPassword`, {
        api_key: api_key,
        user_id: userId,
        password: formik.values.password
      });
      if (updatePassword.data.status == 'status') {
        toast.success(updatePassword.data.showableMessage)
        setSteps(steps + 1)

      }
      else {

      }

    } catch (error: any) {
      toast.error(error.message)
    }
  }

  const handleNext = async () => {
    switch (steps) {
      case 0:
        getOtp()
        break;
      case 1:
        verifyPin()
        break;
      case 2:
        updatePassword()
        break;


    }

  }

  return (
    <>


      <div className="form-group col-12 col-md-9 w-100 ">
      <label className='mb-2 sign_label'>Email</label>
            <input
              type="email"
              className="form-control"
              id="user"
              name="email"
              placeholder="Enter your email"

              value={formik.values.email}
              onChange={formik.handleChange}
            />
            {formik.errors.email && (
              <div id="registerType" className="text-danger">
                {formik.errors.email}
              </div>
            )}

      </div>
    </>
  );
}


